import { Platform } from '@/utils/platform';
import { newInvoke } from '../../QTBridge';
import { call } from '@popo-bridge/web';

/**
 * 前端页面准备好之后，通知客户端
 */
export const callbackToNative = async (params: {
  status: 1 | 0; //1表示成功 0表示失败
  data: Record<string, any>; //返回的结果
  message: string; // 一般用作错误信息的返回,正常情况为空字符串
  sessionId: string | number;
}) => {
  if (Platform.isPOPO && Platform.isPC) {
    await newInvoke({
      methodName: 'callbackToNative',
      params: {},
    });
  }
};
